





































































import { Component, Prop, Vue } from "vue-property-decorator";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";

@Component({
  components: {
    ContainImage,
    ImageButton,
  },
})
export default class ExpansionPanels extends Vue {
  @Prop({ required: true })
  hideRequirements!: string;
  @Prop({ required: true })
  showRequirements!: string;
  @Prop({ required: true })
  requirements!: string;
  @Prop({ required: true })
  hideFaq!: string;
  @Prop({ required: true })
  showFaq!: string;
  @Prop({ required: true })
  faq!: string;
  @Prop({ required: false })
  configStyle!: string;

  isShownRequirements = false;
  isShownFaq = false;
}
